angular.module('leanlaw').directive('llInvoiceTableRow', [function () {
  return {
    restrict: 'EA',
    template: require('./views/invoice-table-row.html'),
    replace: true,
    scope: {
      row: '=ngModel',
      optionSelected: '&',
      disabled: '=',
      qcTooltip: '=',
      rowChecked: '&',
      readonly: '='
    },
    controller: ['$scope', 'userService', function ($scope, userService) {
      userService.me().then(me => {
        $scope.me = me;
      });
      $scope.selectColumn = function (column) {
        if (column === 'charges' && $scope.row.include.charges === true) {
          $scope.row.include.chargeHours = false;
        } else if (column === 'chargeHours' && $scope.row.include.chargeHours === false) {
          $scope.row.include.charges = true;
        }
      };
      $scope.selectRow = function () {
        // Cascade to matters BEFORE notifying the parent -- rowChecked() (bound from
        // invoice.staging.ctrl.js) recomputes the selected-item count, which must see the
        // post-cascade state for a client-row toggle, not the state from just before it.
        if ($scope.row.matters) {
          $scope.row.matters.forEach(matter => {
            matter.included = $scope.row.included;
          });
        }
        if ($scope.rowChecked) {
          $scope.rowChecked();
        }
      };
      $scope.total = function (row) {
        return (row.include.billable ? row.data.amounts.hours : 0) + (row.include.charges ? row.data.amounts.charges : 0) + (row.include.expenses ? row.data.amounts.expenses : 0);
      };
    }]
  };
}]);